import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="min-h-[70vh] flex items-center" data-testid="page-not-found">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24">
                <p className="overline mb-6">Fehler 404</p>
                <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.95] font-medium text-stone-900">
                    Seite nicht<br/>gefunden.
                </h1>
                <p className="mt-8 font-body text-lg font-light text-stone-600 max-w-xl">
                    Leider existiert diese Seite nicht. Kehren Sie zur Startseite zurück.
                </p>
                <Link
                    to="/"
                    className="mt-10 inline-flex items-center gap-2 bg-ink text-paper px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-brand transition-colors"
                >
                    Zur Startseite
                </Link>
            </div>
        </section>
    );
}
